/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderLogic/ChallengeAuthorities/AchieveScoreDailySpiderAuthority',['SolitaireShared/SpiderLogic/SpiderAuthority',
        'SolitaireShared/SpiderLogic/IDailySpiderAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/IAchieveScoreDailyAuthority',
        'SolitaireShared/CardLogic/ChallengeConstants'
        ],
    function (SpiderAuthority, IDailySpiderAuthority, IDailyAuthority, IAchieveScoreDailyAuthority, ChallengeConstants) {
    "use strict";

    var AchieveScoreDailySpiderAuthority = function (param) {
        this.initAchieveScoreDailySpiderAuthority(param);
    };

    AchieveScoreDailySpiderAuthority.constructor = AchieveScoreDailySpiderAuthority;
    AchieveScoreDailySpiderAuthority.prototype = Object.create(IDailySpiderAuthority.prototype);
    IAchieveScoreDailyAuthority.call(AchieveScoreDailySpiderAuthority.prototype);


    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Achieve a score of x"
    /// </summary>
    /// <param name="param">Score which must be obtained</param>
    AchieveScoreDailySpiderAuthority.prototype.initAchieveScoreDailySpiderAuthority = function (param) {
        IDailySpiderAuthority.call(this);

        if (param != null && param[ChallengeConstants.KeyScoreRequired])
            this.ScoreRequired = parseInt(param[ChallengeConstants.KeyScoreRequired]);
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.AchieveScore;
    };
           
    AchieveScoreDailySpiderAuthority.prototype.IsGameWon = function ()
    {
        return (!this.CardSupply.WaitingForAnimation) && this.CardSupply.Score >= this.ScoreRequired;
    };
  
    return AchieveScoreDailySpiderAuthority;

});
